import React from "react";
import { publications } from "../data.js";
import { FaExternalLinkAlt } from "react-icons/fa";

export default function Publications({sectionBg}) {
  const sortedPublications = [...publications].sort((a, b) => new Date(b.date) - new Date(a.date));
  const cardBg = sectionBg === "bg-gray-50" ? "bg-white" : "bg-gray-50";
  return (
    <section id="publications" className={sectionBg + " py-16"}>
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-12 text-center">Publications</h2>
        <div className="grid md:grid-cols-2 gap-8">
          {sortedPublications.map((pub, index) => {
            return (
              <div key={index} className={`${cardBg} p-6 rounded-xl shadow-md hover:shadow-lg transition transform hover:-translate-y-1 flex flex-col`}>
                <h3 className="text-xl font-semibold">{pub.title}</h3>
                <p className="italic text-gray-500 mt-1">{pub.journal} — {pub.date}</p>
                <p className="mt-2 text-gray-700">{pub.summary}</p>
                {pub.authors?.length > 0 && (
                  <p className="mt-2 text-gray-600"><span className="font-semibold">Authors:</span> {pub.authors.join(", ")}</p>
                )}
                {pub.link && (
                  <a href={pub.link} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 pt-3 mt-auto text-blue-600 hover:underline">
                    Read More <FaExternalLinkAlt />
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
